// src/cards.js
export const cardsData = {
  zh: [
    {
      name: "愚者",
      image: "/images-webp/fool.webp",
      upright: "天真、自由、冒险、新开始",
      reversed: "鲁莽、冲动、缺乏计划"
    },
    {
      name: "魔术师",
      image: "/images-webp/magician.webp",
      upright: "行动力、创造力、掌控力",
      reversed: "操控欲、欺骗、潜力未发挥"
    },
    {
      name: "女祭司",
      image: "/images-webp/high-priestess.webp",
      upright: "直觉、智慧、神秘、潜意识",
      reversed: "秘密、误解、忽视直觉"
    },
    {
      name: "女皇",
      image: "/images-webp/empress.webp",
      upright: "丰饶、关爱、创造力",
      reversed: "依赖、浪费、停滞"
    },
    {
      name: "皇帝",
      image: "/images-webp/emperor.webp",
      upright: "权威、结构、稳定、控制",
      reversed: "专制、僵化、失控"
    },
    {
      name: "教皇",
      image: "/images-webp/hierophant.webp",
      upright: "信仰、传统、智慧导师",
      reversed: "盲从、束缚、反叛"
    },
    {
      name: "恋人",
      image: "/images-webp/lovers.webp",
      upright: "爱情、选择、和谐",
      reversed: "冲突、分离、犹豫不决"
    },
    {
      name: "战车",
      image: "/images-webp/chariot.webp",
      upright: "意志力、胜利、决心",
      reversed: "失控、冲动、挫折"
    },
    {
      name: "力量",
      image: "/images-webp/strength.webp",
      upright: "勇气、耐心、内在力量",
      reversed: "软弱、恐惧、失去控制"
    },
    {
      name: "隐者",
      image: "/images-webp/hermit.webp",
      upright: "内省、智慧、孤独探索",
      reversed: "孤立、逃避、迷失"
    },
    {
      name: "命运之轮",
      image: "/images-webp/wheel-of-fortune.webp",
      upright: "机遇、循环、命运变化",
      reversed: "阻碍、倒霉、停滞"
    },
    {
      name: "正义",
      image: "/images-webp/justice.webp",
      upright: "公平、平衡、责任",
      reversed: "偏见、不公、逃避责任"
    },
    {
      name: "倒吊人",
      image: "/images-webp/hanged-man.webp",
      upright: "牺牲、等待、换个角度看问题",
      reversed: "拖延、顽固、拒绝改变"
    },
    {
      name: "死亡",
      image: "/images-webp/death.webp",
      upright: "结束、转变、重生",
      reversed: "抗拒改变、停滞、延迟"
    },
    {
      name: "节制",
      image: "/images-webp/temperance.webp",
      upright: "平衡、节制、调和",
      reversed: "失衡、冲动、极端"
    },
    {
      name: "魔鬼",
      image: "/images-webp/devil.webp",
      upright: "束缚、欲望、诱惑",
      reversed: "解脱、觉醒、摆脱束缚"
    },
    {
      name: "高塔",
      image: "/images-webp/tower.webp",
      upright: "突发事件、破坏、觉醒",
      reversed: "灾难延迟、恐惧、混乱"
    },
    {
      name: "星星",
      image: "/images-webp/star.webp",
      upright: "希望、灵感、指引",
      reversed: "迷茫、失望、缺乏方向"
    },
    {
      name: "月亮",
      image: "/images-webp/moon.webp",
      upright: "直觉、潜意识、幻象",
      reversed: "迷惑、欺骗、恐惧"
    },
    {
      name: "太阳",
      image: "/images-webp/sun.webp",
      upright: "快乐、成功、正能量",
      reversed: "挫折、延迟、阴影"
    },
    {
      name: "审判",
      image: "/images-webp/judgement.webp",
      upright: "觉醒、反思、重生",
      reversed: "拒绝改变、逃避责任"
    },
    {
      name: "世界",
      image: "/images-webp/world.webp",
      upright: "完成、成就、圆满",
      reversed: "延迟、未完成、缺乏目标"
    },
    {
      name: "权杖A",
      image: "/images-webp/wands/ace_of_wands.webp",
      upright: "新的开始、热情、潜力",
      reversed: "延迟、缺乏动力、犹豫"
    },
    {
      name: "权杖2",
      image: "/images-webp/wands/two_of_wands.webp",
      upright: "规划、决策、前景",
      reversed: "不确定、拖延、焦虑"
    },
    {
      name: "权杖3",
      image: "/images-webp/wands/three_of_wands.webp",
      upright: "远见、拓展、冒险",
      reversed: "限制、阻碍、迟疑"
    },
    {
      name: "权杖4",
      image: "/images-webp/wands/four_of_wands.webp",
      upright: "庆祝、稳定、和谐",
      reversed: "冲突、不稳定、延期"
    },
    {
      name: "权杖5",
      image: "/images-webp/wands/five_of_wands.webp",
      upright: "竞争、挑战、磨练",
      reversed: "内耗、妥协、放弃斗争"
    },
    {
      name: "权杖6",
      image: "/images-webp/wands/six_of_wands.webp",
      upright: "胜利、认可、成就",
      reversed: "自负、延迟、挫败"
    },
    {
      name: "权杖7",
      image: "/images-webp/wands/seven_of_wands.webp",
      upright: "坚持、防守、勇气",
      reversed: "退缩、失去信心、冲突"
    },
    {
      name: "权杖8",
      image: "/images-webp/wands/eight_of_wands.webp",
      upright: "迅速行动、进展、消息",
      reversed: "延迟、阻碍、混乱"
    },
    {
      name: "权杖9",
      image: "/images-webp/wands/nine_of_wands.webp",
      upright: "坚持、防御、警觉",
      reversed: "疲惫、放弃、焦虑"
    },
    {
      name: "权杖10",
      image: "/images-webp/wands/ten_of_wands.webp",
      upright: "责任、负担、努力",
      reversed: "压力过大、逃避、拖延"
    },
    {
      name: "权杖侍从",
      image: "/images-webp/wands/page_of_wands.webp",
      upright: "好奇、热情、探索",
      reversed: "冲动、轻率、缺乏方向"
    },
    {
      name: "权杖骑士",
      image: "/images-webp/wands/knight_of_wands.webp",
      upright: "行动力、冒险、热情",
      reversed: "鲁莽、冲动、不可预测"
    },
    {
      name: "权杖皇后",
      image: "/images-webp/wands/queen_of_wands.webp",
      upright: "自信、热情、创造力",
      reversed: "控制欲、嫉妒、傲慢"
    },
    {
      name: "权杖国王",
      image: "/images-webp/wands/king_of_wands.webp",
      upright: "领导力、魅力、决断",
      reversed: "专横、冲动、傲慢"
    },
    {
      name: "圣杯A",
      image: "/images-webp/cups/ace_of_cups.webp",
      upright: "新感情、喜悦、情感的开始",
      reversed: "情感阻塞、失落、延迟"
    },
    {
      name: "圣杯2",
      image: "/images-webp/cups/two_of_cups.webp",
      upright: "合作、爱情、伙伴关系",
      reversed: "分歧、失和、误解"
    },
    {
      name: "圣杯3",
      image: "/images-webp/cups/three_of_cups.webp",
      upright: "庆祝、友情、社交",
      reversed: "聚会失衡、过度放纵"
    },
    {
      name: "圣杯4",
      image: "/images-webp/cups/four_of_cups.webp",
      upright: "沉思、反思、机会被忽视",
      reversed: "消极、拒绝机会、重新审视"
    },
    {
      name: "圣杯5",
      image: "/images-webp/cups/five_of_cups.webp",
      upright: "失落、遗憾、悔恨",
      reversed: "接受、放下、走出失落"
    },
    {
      name: "圣杯6",
      image: "/images-webp/cups/six_of_cups.webp",
      upright: "怀旧、童年、纯真",
      reversed: "停留过去、逃避现实"
    },
    {
      name: "圣杯7",
      image: "/images-webp/cups/seven_of_cups.webp",
      upright: "幻想、选择、多种可能性",
      reversed: "迷茫、优柔寡断、清晰决策"
    },
    {
      name: "圣杯8",
      image: "/images-webp/cups/eight_of_cups.webp",
      upright: "放下、离开、不满足",
      reversed: "回头、逃避、停滞不前"
    },
    {
      name: "圣杯9",
      image: "/images-webp/cups/nine_of_cups.webp",
      upright: "满足、愿望成真、幸福",
      reversed: "虚假满足、贪婪、延迟"
    },
    {
      name: "圣杯10",
      image: "/images-webp/cups/ten_of_cups.webp",
      upright: "家庭幸福、情感圆满",
      reversed: "家庭矛盾、情感失衡"
    },
    {
      name: "圣杯侍从",
      image: "/images-webp/cups/page_of_cups.webp",
      upright: "感性、直觉、创意",
      reversed: "不成熟、情感波动、轻率"
    },
    {
      name: "圣杯骑士",
      image: "/images-webp/cups/knight_of_cups.webp",
      upright: "浪漫、追求梦想、提议",
      reversed: "浮夸、不可靠、虚假承诺"
    },
    {
      name: "圣杯皇后",
      image: "/images-webp/cups/queen_of_cups.webp",
      upright: "关怀、情感丰富、直觉力强",
      reversed: "情绪不稳、依赖、敏感过度"
    },
    {
      name: "圣杯国王",
      image: "/images-webp/cups/king_of_cups.webp",
      upright: "情绪成熟、同理心、智慧",
      reversed: "情绪控制差、冷漠、操控"
    },
    {
      name: "宝剑A",
      image: "/images-webp/swords/ace_of_swords.webp",
      upright: "新思想、洞察力、真理",
      reversed: "混乱、误解、延迟"
    },
    {
      name: "宝剑2",
      image: "/images-webp/swords/two_of_swords.webp",
      upright: "抉择、平衡、权衡利弊",
      reversed: "拖延决策、逃避冲突"
    },
    {
      name: "宝剑3",
      image: "/images-webp/swords/three_of_swords.webp",
      upright: "心痛、分离、失望",
      reversed: "疗伤、释怀、重新开始"
    },
    {
      name: "宝剑4",
      image: "/images-webp/swords/four_of_swords.webp",
      upright: "休息、沉思、恢复",
      reversed: "停滞、焦虑、无法休息"
    },
    {
      name: "宝剑5",
      image: "/images-webp/swords/five_of_swords.webp",
      upright: "冲突、争斗、失败",
      reversed: "和解、收手、避免争端"
    },
    {
      name: "宝剑6",
      image: "/images-webp/swords/six_of_swords.webp",
      upright: "过渡、旅行、离开困境",
      reversed: "停滞、困境未解"
    },
    {
      name: "宝剑7",
      image: "/images-webp/swords/seven_of_swords.webp",
      upright: "策略、机智、隐秘行动",
      reversed: "欺骗被揭露、不诚实"
    },
    {
      name: "宝剑8",
      image: "/images-webp/swords/eight_of_swords.webp",
      upright: "束缚、限制、焦虑",
      reversed: "解脱、勇气、突破困境"
    },
    {
      name: "宝剑9",
      image: "/images-webp/swords/nine_of_swords.webp",
      upright: "焦虑、噩梦、精神压力",
      reversed: "缓解压力、释放心灵"
    },
    {
      name: "宝剑10",
      image: "/images-webp/swords/ten_of_swords.webp",
      upright: "彻底失败、痛苦结束",
      reversed: "重生、从痛苦中恢复"
    },
    {
      name: "宝剑侍从",
      image: "/images-webp/swords/page_of_swords.webp",
      upright: "好奇、学习、敏捷思维",
      reversed: "冲动、缺乏计划、狡诈"
    },
    {
      name: "宝剑骑士",
      image: "/images-webp/swords/knight_of_swords.webp",
      upright: "行动迅速、果断、冒险",
      reversed: "鲁莽、冲动、好战"
    },
    {
      name: "宝剑皇后",
      image: "/images-webp/swords/queen_of_swords.webp",
      upright: "独立、智慧、理性",
      reversed: "冷漠、尖酸、刻薄"
    },
    {
      name: "宝剑国王",
      image: "/images-webp/swords/king_of_swords.webp",
      upright: "权威、理智、判断力强",
      reversed: "专横、冷酷、不公正"
    },
    {
      name: "星币A",
      image: "/images-webp/pentacles/ace_of_pentacles.webp",
      upright: "新机遇、财富、物质成功",
      reversed: "机会错失、财务困扰、延迟"
    },
    {
      name: "星币2",
      image: "/images-webp/pentacles/two_of_pentacles.webp",
      upright: "平衡、灵活、应对变化",
      reversed: "失衡、压力过大、应对不当"
    },
    {
      name: "星币3",
      image: "/images-webp/pentacles/three_of_pentacles.webp",
      upright: "团队合作、技能、认同",
      reversed: "缺乏合作、技能不足、评价不佳"
    },
    {
      name: "星币4",
      image: "/images-webp/pentacles/four_of_pentacles.webp",
      upright: "保守、节俭、守护财富",
      reversed: "贪婪、浪费、过度控制"
    },
    {
      name: "星币5",
      image: "/images-webp/pentacles/five_of_pentacles.webp",
      upright: "经济困难、失落、孤立",
      reversed: "改善、援助、恢复信心"
    },
    {
      name: "星币6",
      image: "/images-webp/pentacles/six_of_pentacles.webp",
      upright: "慷慨、资助、平衡给予",
      reversed: "不平等、施舍有条件、贪婪"
    },
    {
      name: "星币7",
      image: "/images-webp/pentacles/seven_of_pentacles.webp",
      upright: "耐心、投资回报、评估进展",
      reversed: "急功近利、努力无果、失望"
    },
    {
      name: "星币8",
      image: "/images-webp/pentacles/eight_of_pentacles.webp",
      upright: "勤奋、专注、技能提升",
      reversed: "懒惰、粗心、缺乏专注"
    },
    {
      name: "星币9",
      image: "/images-webp/pentacles/nine_of_pentacles.webp",
      upright: "独立、享受成果、富足",
      reversed: "自负、孤立、依赖他人"
    },
    {
      name: "星币10",
      image: "/images-webp/pentacles/ten_of_pentacles.webp",
      upright: "家庭财富、传承、安全感",
      reversed: "财务问题、家族冲突、失衡"
    },
    {
      name: "星币侍从",
      image: "/images-webp/pentacles/page_of_pentacles.webp",
      upright: "学习新技能、踏实、求知欲",
      reversed: "浮躁、缺乏计划、好高骛远"
    },
    {
      name: "星币骑士",
      image: "/images-webp/pentacles/knight_of_pentacles.webp",
      upright: "勤勉、稳重、可靠",
      reversed: "拖延、固执、缺乏行动"
    },
    {
      name: "星币皇后",
      image: "/images-webp/pentacles/queen_of_pentacles.webp",
      upright: "富有、勤劳、照顾家庭",
      reversed: "物质过度、忽略感情、依赖"
    },
    {
      name: "星币国王",
      image: "/images-webp/pentacles/king_of_pentacles.webp",
      upright: "财富掌控、成功、实际",
      reversed: "贪婪、固执、财务问题"
    }
  ],
  en: [
    {
      name: "The Fool",
      image: "/images-webp/fool.webp", 
      upright: "New beginnings, adventure, innocence, unlimited potential",
      reversed: "Recklessness, naivety, hesitation, risk of folly"
    },
    {
      name: "The Magician",
      image: "/images-webp/magician.webp",
      upright: "Manifestation, skill, inspired action, personal power",
      reversed: "Manipulation, untapped potential, deceit, lack of focus"
    },
    {
      name: "The High Priestess",
      image: "/images-webp/high-priestess.webp",
      upright: "Intuition, hidden knowledge, the mysteries of the subconscious",
      reversed: "Secrets revealed, misunderstanding, ignoring inner wisdom"
    },
    {
      name: "The Empress",
      image: "/images-webp/empress.webp",
      upright: "Abundance, nurturing, creativity, fertility",
      reversed: "Dependency, wastefulness, creative blocks"
    },
    {
      name: "The Emperor",
      image: "/images-webp/emperor.webp",
      upright: "Authority, structure, stability, control",
      reversed: "Rigidity, tyranny, loss of control"
    },
    {
      name: "The Hierophant",
      image: "/images-webp/hierophant.webp",
      upright: "Tradition, spiritual guidance, wisdom from mentors",
      reversed: "Blind conformity, restriction, rebellion against rules"
    },
    {
      name: "The Lovers",
      image: "/images-webp/lovers.webp",
      upright: "Love, harmony, meaningful choices",
      reversed: "Conflict, separation, indecision"
    },
    {
      name: "The Chariot",
      image: "/images-webp/chariot.webp",
      upright: "Determination, willpower, victory through focus",
      reversed: "Loss of control, recklessness, setbacks"
    },
    {
      name: "Strength",
      image: "/images-webp/strength.webp",
      upright: "Courage, patience, inner strength, resilience",
      reversed: "Weakness, fear, losing control"
    },
    {
      name: "The Hermit",
      image: "/images-webp/hermit.webp",
      upright: "Introspection, solitude, the search for wisdom",
      reversed: "Isolation, avoidance, feeling lost"
    },
    {
      name: "Wheel of Fortune",
      image: "/images-webp/wheel-of-fortune.webp",
      upright: "Cycles, destiny, opportunity and change",
      reversed: "Obstacles, bad luck, stagnation"
    },
    {
      name: "Justice",
      image: "/images-webp/justice.webp",
      upright: "Fairness, balance, truth, responsibility",
      reversed: "Bias, injustice, evading responsibility"
    },
    {
      name: "The Hanged Man",
      image: "/images-webp/hanged-man.webp",
      upright: "Pause, surrender, seeing things from a new perspective",
      reversed: "Stubbornness, delays, resisting change"
    },
    {
      name: "Death",
      image: "/images-webp/death.webp",
      upright: "Transformation, endings, rebirth",
      reversed: "Resistance to change, stagnation, delays"
    },
    {
      name: "Temperance",
      image: "/images-webp/temperance.webp",
      upright: "Balance, moderation, harmony, integration",
      reversed: "Imbalance, extremes, impulsiveness"
    },
    {
      name: "The Devil",
      image: "/images-webp/devil.webp",
      upright: "Bondage, temptation, facing desires",
      reversed: "Liberation, awakening, breaking free"
    },
    {
      name: "The Tower",
      image: "/images-webp/tower.webp",
      upright: "Sudden upheaval, revelation, awakening",
      reversed: "Delayed disaster, fear, lingering chaos"
    },
    {
      name: "The Star",
      image: "/images-webp/star.webp",
      upright: "Hope, inspiration, guidance, renewal",
      reversed: "Confusion, disappointment, lack of direction"
    },
    {
      name: "The Moon",
      image: "/images-webp/moon.webp",
      upright: "Intuition, illusions, the subconscious mind",
      reversed: "Deception, fear, uncertainty"
    },
    {
      name: "The Sun",
      image: "/images-webp/sun.webp",
      upright: "Joy, success, vitality, clarity",
      reversed: "Delays, setbacks, shadows"
    },
    {
      name: "Judgement",
      image: "/images-webp/judgement.webp",
      upright: "Awakening, reflection, rebirth, self-realization",
      reversed: "Avoiding change, fear of accountability"
    },
    {
      name: "The World",
      image: "/images-webp/world.webp",
      upright: "Completion, achievement, fulfillment, wholeness",
      reversed: "Delays, incompletion, lack of closure"
    },
    {
      name: "Ace of Wands",
      image: "/images-webp/wands/ace_of_wands.webp",
      upright: "A spark of inspiration, new beginnings, untapped potential",
      reversed: "Delays, lack of motivation, hesitation to act"
    },
    {
      name: "Two of Wands",
      image: "/images-webp/wands/two_of_wands.webp",
      upright: "Planning your path, weighing possibilities, visionary foresight",
      reversed: "Uncertainty clouds decisions, procrastination, anxiety"
    },
    {
      name: "Three of Wands",
      image: "/images-webp/wands/three_of_wands.webp",
      upright: "Expansion, foresight, the thrill of adventure",
      reversed: "Obstacles arise, restrictions, hesitation to move forward"
    },
    {
      name: "Four of Wands",
      image: "/images-webp/wands/four_of_wands.webp",
      upright: "Celebration, stability, harmony in achievements",
      reversed: "Conflict, instability, delayed joy"
    },
    {
      name: "Five of Wands",
      image: "/images-webp/wands/five_of_wands.webp",
      upright: "Challenge, competition, the forging of strength",
      reversed: "Inner conflict, compromise, surrendering the struggle"
    },
    {
      name: "Six of Wands",
      image: "/images-webp/wands/six_of_wands.webp",
      upright: "Victory, recognition, shining achievements",
      reversed: "Arrogance, delayed success, setbacks"
    },
    {
      name: "Seven of Wands",
      image: "/images-webp/wands/seven_of_wands.webp",
      upright: "Standing your ground, defending your position, courage",
      reversed: "Retreat, loss of confidence, ongoing conflict"
    },
    {
      name: "Eight of Wands",
      image: "/images-webp/wands/eight_of_wands.webp",
      upright: "Swift action, rapid progress, incoming news",
      reversed: "Delays, obstacles, confusion"
    },
    {
      name: "Nine of Wands",
      image: "/images-webp/wands/nine_of_wands.webp",
      upright: "Persistence, vigilance, resilience in adversity",
      reversed: "Exhaustion, giving up, mental strain"
    },
    {
      name: "Ten of Wands",
      image: "/images-webp/wands/ten_of_wands.webp",
      upright: "Bearing responsibility, the weight of effort, diligence",
      reversed: "Overwhelm, avoidance, procrastination"
    },
    {
      name: "Page of Wands",
      image: "/images-webp/wands/page_of_wands.webp",
      upright: "Curiosity, fiery enthusiasm, exploration of new ideas",
      reversed: "Impulsiveness, recklessness, lack of direction"
    },
    {
      name: "Knight of Wands",
      image: "/images-webp/wands/knight_of_wands.webp",
      upright: "Bold action, adventure, chasing dreams with passion",
      reversed: "Reckless haste, impulsivity, unpredictability"
    },
    {
      name: "Queen of Wands",
      image: "/images-webp/wands/queen_of_wands.webp",
      upright: "Confidence, creative energy, magnetic charisma",
      reversed: "Overbearing control, jealousy, arrogance"
    },
    {
      name: "King of Wands",
      image: "/images-webp/wands/king_of_wands.webp",
      upright: "Visionary leadership, charm, decisive authority",
      reversed: "Domineering, impulsive, prideful"
    },
    {
      name: "Ace of Cups",
      image: "/images-webp/cups/ace_of_cups.webp",
      upright: "A flow of new emotions, joy, and the start of heartfelt connections",
      reversed: "Emotional blockages, loss, delayed feelings"
    },
    {
      name: "Two of Cups",
      image: "/images-webp/cups/two_of_cups.webp",
      upright: "Union, partnership, love in harmony",
      reversed: "Disagreement, disharmony, misunderstandings"
    },
    {
      name: "Three of Cups",
      image: "/images-webp/cups/three_of_cups.webp",
      upright: "Celebration, joyful friendships, social harmony",
      reversed: "Imbalanced gatherings, overindulgence, fleeting pleasure"
    },
    {
      name: "Four of Cups",
      image: "/images-webp/cups/four_of_cups.webp",
      upright: "Contemplation, introspection, overlooked opportunities",
      reversed: "Negativity lifted, reevaluation, opening to new chances"
    },
    {
      name: "Five of Cups",
      image: "/images-webp/cups/five_of_cups.webp",
      upright: "Grief, regret, mourning lost possibilities",
      reversed: "Acceptance, release, moving forward with hope"
    },
    {
      name: "Six of Cups",
      image: "/images-webp/cups/six_of_cups.webp",
      upright: "Nostalgia, childhood memories, innocence",
      reversed: "Clinging to the past, escapism, avoiding reality"
    },
    {
      name: "Seven of Cups",
      image: "/images-webp/cups/seven_of_cups.webp",
      upright: "Dreams, illusions, countless possibilities",
      reversed: "Confusion clears, indecision resolved, clarity emerges"
    },
    {
      name: "Eight of Cups",
      image: "/images-webp/cups/eight_of_cups.webp",
      upright: "Walking away, seeking deeper meaning, leaving dissatisfaction behind",
      reversed: "Returning, avoidance, stagnation in emotion"
    },
    {
      name: "Nine of Cups",
      image: "/images-webp/cups/nine_of_cups.webp",
      upright: "Contentment, wishes fulfilled, emotional satisfaction",
      reversed: "Superficial happiness, greed, delayed gratification"
    },
    {
      name: "Ten of Cups",
      image: "/images-webp/cups/ten_of_cups.webp",
      upright: "Harmony in family and relationships, emotional fulfillment",
      reversed: "Family tension, imbalance, emotional strain"
    },
    {
      name: "Page of Cups",
      image: "/images-webp/cups/page_of_cups.webp",
      upright: "Intuition, creativity, tender emotions",
      reversed: "Immaturity, mood swings, impulsive feelings"
    },
    {
      name: "Knight of Cups",
      image: "/images-webp/cups/knight_of_cups.webp",
      upright: "Romantic pursuits, following dreams, heartfelt proposals",
      reversed: "Flamboyance, unreliability, empty promises"
    },
    {
      name: "Queen of Cups",
      image: "/images-webp/cups/queen_of_cups.webp",
      upright: "Compassion, deep emotional insight, intuitive guidance",
      reversed: "Emotional turbulence, dependency, hypersensitivity"
    },
    {
      name: "King of Cups",
      image: "/images-webp/cups/king_of_cups.webp",
      upright: "Emotional maturity, wisdom, empathy in action",
      reversed: "Poor emotional control, coldness, manipulation"
    },
    {
      name: "Ace of Swords",
      image: "/images-webp/swords/ace_of_swords.webp",
      upright: "A spark of clarity, new ideas, piercing truth",
      reversed: "Confusion clouds the mind, miscommunication, delays"
    },
    {
      name: "Two of Swords",
      image: "/images-webp/swords/two_of_swords.webp",
      upright: "A crossroads of choices, balancing logic and heart",
      reversed: "Indecision lingers, avoiding necessary conflict"
    },
    {
      name: "Three of Swords",
      image: "/images-webp/swords/three_of_swords.webp",
      upright: "Heartache, sorrow, the pain of separation",
      reversed: "Healing begins, forgiveness, renewal of hope"
    },
    {
      name: "Four of Swords",
      image: "/images-webp/swords/four_of_swords.webp",
      upright: "Solitude for reflection, rest, mental restoration",
      reversed: "Restlessness, tension, inability to find peace"
    },
    {
      name: "Five of Swords",
      image: "/images-webp/swords/five_of_swords.webp",
      upright: "Tension, conflict, battles of the mind",
      reversed: "Surrendering strife, seeking reconciliation, letting go"
    },
    {
      name: "Six of Swords",
      image: "/images-webp/swords/six_of_swords.webp",
      upright: "Transition, moving toward calmer waters, leaving struggles behind",
      reversed: "Stuck in turmoil, unable to move forward"
    },
    {
      name: "Seven of Swords",
      image: "/images-webp/swords/seven_of_swords.webp",
      upright: "Cunning, strategy, secret maneuvers",
      reversed: "Deception exposed, dishonesty revealed"
    },
    {
      name: "Eight of Swords",
      image: "/images-webp/swords/eight_of_swords.webp",
      upright: "Bound by fear, trapped by circumstance, mental chains",
      reversed: "Breaking free, courage awakens, liberation"
    },
    {
      name: "Nine of Swords",
      image: "/images-webp/swords/nine_of_swords.webp",
      upright: "Nightmares, anxiety, the weight of worry",
      reversed: "Release from torment, easing mental burdens"
    },
    {
      name: "Ten of Swords",
      image: "/images-webp/swords/ten_of_swords.webp",
      upright: "The end of suffering, complete collapse, painful closure",
      reversed: "Rising anew, recovering from hardship, rebirth"
    },
    {
      name: "Page of Swords",
      image: "/images-webp/swords/page_of_swords.webp",
      upright: "Curious mind, sharp intellect, a seeker of truth",
      reversed: "Impulsive thoughts, reckless decisions, cunning misuse"
    },
    {
      name: "Knight of Swords",
      image: "/images-webp/swords/knight_of_swords.webp",
      upright: "Bold action, swift movement, fearless pursuit",
      reversed: "Reckless haste, aggression, headstrong folly"
    },
    {
      name: "Queen of Swords",
      image: "/images-webp/swords/queen_of_swords.webp",
      upright: "Clarity of mind, independence, discerning wisdom",
      reversed: "Harsh judgment, cold detachment, sharp words"
    },
    {
      name: "King of Swords",
      image: "/images-webp/swords/king_of_swords.webp",
      upright: "Authority, intellect, mastery of logic and judgment",
      reversed: "Tyranny, cold-heartedness, misuse of power"
    },
    {
      name: "Ace of Pentacles",
      image: "/images-webp/pentacles/ace_of_pentacles.webp",
      upright: "A new opportunity, prosperity, material beginnings",
      reversed: "Missed chance, financial delay, lack of focus"
    },
    {
      name: "Two of Pentacles",
      image: "/images-webp/pentacles/two_of_pentacles.webp",
      upright: "Balance, adaptability, juggling priorities",
      reversed: "Overwhelm, instability, poor time management"
    },
    {
      name: "Three of Pentacles",
      image: "/images-webp/pentacles/three_of_pentacles.webp",
      upright: "Collaboration, skillful effort, recognition",
      reversed: "Lack of teamwork, undervalued effort, misalignment"
    },
    {
      name: "Four of Pentacles",
      image: "/images-webp/pentacles/four_of_pentacles.webp",
      upright: "Security, stability, holding onto resources",
      reversed: "Greed, possessiveness, fear of loss"
    },
    {
      name: "Five of Pentacles",
      image: "/images-webp/pentacles/five_of_pentacles.webp",
      upright: "Hardship, financial struggle, isolation",
      reversed: "Recovery, hope, finding support"
    },
    {
      name: "Six of Pentacles",
      image: "/images-webp/pentacles/six_of_pentacles.webp",
      upright: "Generosity, balance in giving and receiving",
      reversed: "Selfishness, inequality, strings attached"
    },
    {
      name: "Seven of Pentacles",
      image: "/images-webp/pentacles/seven_of_pentacles.webp",
      upright: "Patience, long-term planning, reflection on progress",
      reversed: "Impatience, frustration, lack of growth"
    },
    {
      name: "Eight of Pentacles",
      image: "/images-webp/pentacles/eight_of_pentacles.webp",
      upright: "Diligence, mastery, dedicated work",
      reversed: "Perfectionism, wasted effort, lack of focus"
    },
    {
      name: "Nine of Pentacles",
      image: "/images-webp/pentacles/nine_of_pentacles.webp",
      upright: "Independence, prosperity, self-sufficiency",
      reversed: "Overdependence, financial insecurity, superficial success"
    },
    {
      name: "Ten of Pentacles",
      image: "/images-webp/pentacles/ten_of_pentacles.webp",
      upright: "Legacy, family wealth, long-term stability",
      reversed: "Financial loss, family disputes, instability"
    },
    {
      name: "Page of Pentacles",
      image: "/images-webp/pentacles/page_of_pentacles.webp",
      upright: "Curiosity, ambition, practical learning",
      reversed: "Lack of focus, procrastination, immaturity"
    },
    {
      name: "Knight of Pentacles",
      image: "/images-webp/pentacles/knight_of_pentacles.webp",
      upright: "Hard work, reliability, steady progress",
      reversed: "Stubbornness, laziness, slow movement"
    },
    {
      name: "Queen of Pentacles",
      image: "/images-webp/pentacles/queen_of_pentacles.webp",
      upright: "Nurturing, practical wisdom, abundance",
      reversed: "Overly cautious, dependence, materialism"
    },
    {
      name: "King of Pentacles",
      image: "/images-webp/pentacles/king_of_pentacles.webp",
      upright: "Wealth, stability, mastery of material life",
      reversed: "Greed, rigidity, misuse of power"
    },
  ],
  ar: [
    {
      name: "الأَحْمَق",
      image: "/images-webp/fool.webp",
      upright: "بدايات جديدة، مغامرة، براءة، إمكانات غير محدودة",
      reversed: "تهور، سذاجة، تردد، مخاطرة متهورة"
    },
    {
      name: "السّاحِر",
      image: "/images-webp/magician.webp",
      upright: "تجلي، مهارة، فعل مُلهم، قوة شخصية",
      reversed: "تلاعب، قدرات غير مُستغَلة، خداع، افتقاد التركيز"
    },
    {
      name: "الكاهنة العُليا",
      image: "/images-webp/high-priestess.webp",
      upright: "حدس، معرفة خفية، أسرار العقل الباطن",
      reversed: "أسرار مكشوفة، سوء فهم، تجاهل الحكمة الداخلية"
    },
    {
      name: "الإمبراطورة",
      image: "/images-webp/empress.webp",
      upright: "وفرة، رعاية، إبداع، خصوبة",
      reversed: "اعتمادية، تبذير، عوائق إبداعية"
    },
    {
      name: "الإمبراطور",
      image: "/images-webp/emperor.webp",
      upright: "سلطة، هيكل، استقرار، سيطرة",
      reversed: "صلابة، استبداد، فقدان السيطرة"
    },
    {
      name: "المُرشد الروحي",
      image: "/images-webp/hierophant.webp",
      upright: "تقليد، إرشاد روحي، حكمة من المعلمين",
      reversed: "اتباع أعمى، قيود، تمرد على القواعد"
    },
    {
      name: "العشّاق",
      image: "/images-webp/lovers.webp",
      upright: "حب، تناغم، خيارات ذات معنى",
      reversed: "صراع، انفصال، تردد"
    },
    {
      name: "المركبة",
      image: "/images-webp/chariot.webp",
      upright: "إرادة، عزيمة، انتصار من خلال التركيز",
      reversed: "فقدان السيطرة، تهور، نكسات"
    },
    {
      name: "القوة",
      image: "/images-webp/strength.webp",
      upright: "شجاعة، صبر، قوة داخلية، مرونة",
      reversed: "ضعف، خوف، فقدان السيطرة"
    },
    {
      name: "الناسك",
      image: "/images-webp/hermit.webp",
      upright: "تأمل، وحدة، البحث عن الحكمة",
      reversed: "عزلة، هروب، شعور بالضياع"
    },
    {
      name: "عجلة الحظ",
      image: "/images-webp/wheel-of-fortune.webp",
      upright: "دورات الحياة، القدر، الفرص والتغيير",
      reversed: "عوائق، سوء الحظ، ركود"
    },
    {
      name: "العدالة",
      image: "/images-webp/justice.webp",
      upright: "إنصاف، توازن، الحقيقة، مسؤولية",
      reversed: "تحيز، ظلم، الهروب من المسؤولية"
    },
    {
      name: "الرجل المعلق",
      image: "/images-webp/hanged-man.webp",
      upright: "توقف، استسلام، رؤية الأمور من منظور جديد",
      reversed: "عناد، تأجيل، مقاومة التغيير"
    },
    {
      name: "الموت",
      image: "/images-webp/death.webp",
      upright: "تحول، نهايات، ولادة جديدة",
      reversed: "مقاومة التغيير، ركود، تأخير"
    },
    {
      name: "الاعتدال",
      image: "/images-webp/temperance.webp",
      upright: "توازن، اعتدال، انسجام، تكامل",
      reversed: "اختلال، تطرف، اندفاع"
    },
    {
      name: "الشيطان",
      image: "/images-webp/devil.webp",
      upright: "قيود، إغراء، مواجهة الرغبات",
      reversed: "تحرر، يقظة، كسر القيود"
    },
    {
      name: "البرج",
      image: "/images-webp/tower.webp",
      upright: "انقلاب مفاجئ، كشف، صحوة",
      reversed: "تأجيل الكارثة، خوف، فوضى مستمرة"
    },
    {
      name: "النجمة",
      image: "/images-webp/star.webp",
      upright: "أمل، إلهام، إرشاد، تجدد",
      reversed: "ارتباك، خيبة أمل، فقدان الاتجاه"
    },
    {
      name: "القمر",
      image: "/images-webp/moon.webp",
      upright: "حدس، أوهام، العقل الباطن",
      reversed: "خداع، خوف، عدم يقين"
    },
    {
      name: "الشمس",
      image: "/images-webp/sun.webp",
      upright: "فرح، نجاح، حيوية، وضوح",
      reversed: "تأخير، نكسات، ظلال"
    },
    {
      name: "الحكم",
      image: "/images-webp/judgement.webp",
      upright: "يقظة، تأمل، ولادة جديدة، وعي الذات",
      reversed: "تجنب التغيير، الخوف من المساءلة"
    },
    {
      name: "العالم",
      image: "/images-webp/world.webp",
      upright: "اكتمال، إنجاز، تحقيق، كمال",
      reversed: "تأخير، عدم اكتمال، فقدان الهدف"
    },
    {
      name: "آص العصي",
      image: "/images-webp/wands/ace_of_wands.webp",
      upright: "شرارة إلهام، بداية جديدة، إمكانات غير مستغلة",
      reversed: "تأجيل، فقدان الحافز، التردد في اتخاذ القرار"
    },
    {
      name: "اثنان من العصي",
      image: "/images-webp/wands/two_of_wands.webp",
      upright: "تخطيط المسار، وزن الاحتمالات، البصيرة",
      reversed: "عدم اليقين، المماطلة، القلق"
    },
    {
      name: "ثلاثة من العصي",
      image: "/images-webp/wands/three_of_wands.webp",
      upright: "توسع، رؤية بعيدة، متعة المغامرة",
      reversed: "عوائق، قيود، التردد في التقدم"
    },
    {
      name: "أربعة من العصي",
      image: "/images-webp/wands/four_of_wands.webp",
      upright: "احتفال، استقرار، انسجام في الإنجازات",
      reversed: "صراع، عدم استقرار، تأجيل الفرح"
    },
    {
      name: "خمسة من العصي",
      image: "/images-webp/wands/five_of_wands.webp",
      upright: "تحديات، منافسة، صقل القوة",
      reversed: "صراعات داخلية، تنازلات، التخلي عن الصراع"
    },
    {
      name: "ستة من العصي",
      image: "/images-webp/wands/six_of_wands.webp",
      upright: "انتصار، تقدير، إنجازات بارزة",
      reversed: "غرور، تأجيل النجاح، نكسات"
    },
    {
      name: "سبعة من العصي",
      image: "/images-webp/wands/seven_of_wands.webp",
      upright: "الثبات، الدفاع عن الموقف، الشجاعة",
      reversed: "تراجع، فقدان الثقة، استمرار الصراع"
    },
    {
      name: "ثمانية من العصي",
      image: "/images-webp/wands/eight_of_wands.webp",
      upright: "عمل سريع، تقدم سريع، أخبار واردة",
      reversed: "تأخير، عوائق، ارتباك"
    },
    {
      name: "تسعة من العصي",
      image: "/images-webp/wands/nine_of_wands.webp",
      upright: "الإصرار، اليقظة، الصمود أمام الشدائد",
      reversed: "إرهاق، استسلام، ضغط نفسي"
    },
    {
      name: "عشرة من العصي",
      image: "/images-webp/wands/ten_of_wands.webp",
      upright: "تحمل المسؤولية، عبء الجهد، الاجتهاد",
      reversed: "ضغط مفرط، هروب، المماطلة"
    },
    {
      name: "صفحة العصي",
      image: "/images-webp/wands/page_of_wands.webp",
      upright: "فضول، حماسة نارية، استكشاف الأفكار الجديدة",
      reversed: "تهور، تهور في التصرف، نقص الاتجاه"
    },
    {
      name: "فارس العصي",
      image: "/images-webp/wands/knight_of_wands.webp",
      upright: "عمل جريء، مغامرة، متابعة الأحلام بشغف",
      reversed: "تهور، اندفاع، عدم التنبؤ"
    },
    {
      name: "ملكة العصي",
      image: "/images-webp/wands/queen_of_wands.webp",
      upright: "ثقة بالنفس، طاقة إبداعية، جاذبية ساحرة",
      reversed: "سيطرة مفرطة، غيرة، غرور"
    },
    {
      name: "ملك العصي",
      image: "/images-webp/wands/king_of_wands.webp",
      upright: "قيادة ذات رؤية، سحر، حسم القرارات",
      reversed: "استبداد، اندفاع، كبرياء"
    },
    {
      name: "آص الكؤوس",
      image: "/images-webp/cups/ace_of_cups.webp",
      upright: "تدفق مشاعر جديدة، فرح، بداية الروابط العاطفية",
      reversed: "انسداد عاطفي، فقدان، تأخير المشاعر"
    },
    {
      name: "اثنان من الكؤوس",
      image: "/images-webp/cups/two_of_cups.webp",
      upright: "اتحاد، شراكة، حب متناغم",
      reversed: "اختلاف، عدم انسجام، سوء تفاهم"
    },
    {
      name: "ثلاثة من الكؤوس",
      image: "/images-webp/cups/three_of_cups.webp",
      upright: "احتفال، صداقات مبهجة، انسجام اجتماعي",
      reversed: "اختلال في التجمعات، إفراط في الانغماس، متعة عابرة"
    },
    {
      name: "أربعة من الكؤوس",
      image: "/images-webp/cups/four_of_cups.webp",
      upright: "تأمل، تفكير داخلي، فرص مُهملة",
      reversed: "رفع السلبية، إعادة تقييم، الانفتاح على فرص جديدة"
    },
    {
      name: "خمسة من الكؤوس",
      image: "/images-webp/cups/five_of_cups.webp",
      upright: "حزن، ندم، الالتحام بالخسائر",
      reversed: "قبول، تخلي، المضي قدمًا بالأمل"
    },
    {
      name: "ستة من الكؤوس",
      image: "/images-webp/cups/six_of_cups.webp",
      upright: "الحنين للماضي، ذكريات الطفولة، البراءة",
      reversed: "التمسك بالماضي، الهروب من الواقع"
    },
    {
      name: "سبعة من الكؤوس",
      image: "/images-webp/cups/seven_of_cups.webp",
      upright: "أحلام، أوهام، احتمالات متعددة",
      reversed: "وضوح الرؤية، حل التردد، اتخاذ قرارات صائبة"
    },
    {
      name: "ثمانية من الكؤوس",
      image: "/images-webp/cups/eight_of_cups.webp",
      upright: "ترك، البحث عن معنى أعمق، الابتعاد عن عدم الرضا",
      reversed: "العودة، الهروب، الركود العاطفي"
    },
    {
      name: "تسعة من الكؤوس",
      image: "/images-webp/cups/nine_of_cups.webp",
      upright: "رضا، تحقيق الأمنيات، سعادة عاطفية",
      reversed: "رضا سطحي، جشع، تأجيل المتعة"
    },
    {
      name: "عشرة من الكؤوس",
      image: "/images-webp/cups/ten_of_cups.webp",
      upright: "انسجام عائلي وعاطفي، تحقيق الاكتمال",
      reversed: "توتر عائلي، خلل عاطفي"
    },
    {
      name: "صفحة الكؤوس",
      image: "/images-webp/cups/page_of_cups.webp",
      upright: "حدس، إبداع، مشاعر رقيقة",
      reversed: "عدم نضج، تقلبات عاطفية، تصرف متهور"
    },
    {
      name: "فارس الكؤوس",
      image: "/images-webp/cups/knight_of_cups.webp",
      upright: "مطاردة رومانسية، متابعة الأحلام، عروض قلبية",
      reversed: "مبالغة، عدم موثوقية، وعود كاذبة"
    },
    {
      name: "ملكة الكؤوس",
      image: "/images-webp/cups/queen_of_cups.webp",
      upright: "تعاطف، بصيرة عاطفية عميقة، حدس قوي",
      reversed: "اضطراب عاطفي، اعتماد، حساسية مفرطة"
    },
    {
      name: "ملك الكؤوس",
      image: "/images-webp/cups/king_of_cups.webp",
      upright: "نضج عاطفي، حكمة، تعاطف فعال",
      reversed: "سوء السيطرة العاطفية، برود، تلاعب"
    },
    {
      name: "آص السيوف",
      image: "/images-webp/swords/ace_of_swords.webp",
      upright: "أفكار جديدة، بصيرة، الحقيقة",
      reversed: "فوضى، سوء فهم، تأخير"
    },
    {
      name: "اثنان من السيوف",
      image: "/images-webp/swords/two_of_swords.webp",
      upright: "اتخاذ قرار، توازن، وزن الإيجابيات والسلبيات",
      reversed: "تأجيل القرار، تجنب الصراع"
    },
    {
      name: "ثلاثة من السيوف",
      image: "/images-webp/swords/three_of_swords.webp",
      upright: "وجع قلب، انفصال، خيبة أمل",
      reversed: "شفاء، إطلاق، بداية جديدة"
    },
    {
      name: "أربعة من السيوف",
      image: "/images-webp/swords/four_of_swords.webp",
      upright: "راحة، تأمل، استشفاء",
      reversed: "ركود، قلق، صعوبة في الاستراحة"
    },
    {
      name: "خمسة من السيوف",
      image: "/images-webp/swords/five_of_swords.webp",
      upright: "صراع، نزاع، خسارة",
      reversed: "تصالح، التوقف عن الجدال، تجنب النزاع"
    },
    {
      name: "ستة من السيوف",
      image: "/images-webp/swords/six_of_swords.webp",
      upright: "انتقال، سفر، الخروج من مأزق",
      reversed: "ركود، استمرار المشكلات"
    },
    {
      name: "سبعة من السيوف",
      image: "/images-webp/swords/seven_of_swords.webp",
      upright: "استراتيجية، ذكاء، أعمال سرية",
      reversed: "كشف الخداع، عدم الأمانة"
    },
    {
      name: "ثمانية من السيوف",
      image: "/images-webp/swords/eight_of_swords.webp",
      upright: "قيود، محددات، قلق",
      reversed: "تحرر، شجاعة، تجاوز العقبات"
    },
    {
      name: "تسعة من السيوف",
      image: "/images-webp/swords/nine_of_swords.webp",
      upright: "قلق، كوابيس، ضغط نفسي",
      reversed: "تخفيف الضغط، تحرير الروح"
    },
    {
      name: "عشرة من السيوف",
      image: "/images-webp/swords/ten_of_swords.webp",
      upright: "فشل تام، نهاية مؤلمة",
      reversed: "ولادة جديدة، التعافي من الألم"
    },
    {
      name: "صفحة السيوف",
      image: "/images-webp/swords/page_of_swords.webp",
      upright: "فضول، تعلم، ذهن سريع",
      reversed: "تهور، نقص التخطيط، خداع"
    },
    {
      name: "فارس السيوف",
      image: "/images-webp/swords/knight_of_swords.webp",
      upright: "تصرف سريع، حسم، مغامرة",
      reversed: "تهور، اندفاع، نزاع"
    },
    {
      name: "ملكة السيوف",
      image: "/images-webp/swords/queen_of_swords.webp",
      upright: "استقلال، حكمة، عقلانية",
      reversed: "برود، لاذعة، قاسية"
    },
    {
      name: "ملك السيوف",
      image: "/images-webp/swords/king_of_swords.webp",
      upright: "سلطة، عقلانية، قدرة على الحكم",
      reversed: "استبداد، قسوة، ظلم"
    },
    {
      name: "آص العملات",
      image: "/images-webp/pentacles/ace_of_pentacles.webp",
      upright: "فرصة جديدة، ازدهار، بداية مادية",
      reversed: "فرصة ضائعة، تأخير مالي، فقدان التركيز"
    },
    {
      name: "اثنان من العملات",
      image: "/images-webp/pentacles/two_of_pentacles.webp",
      upright: "توازن، مرونة، إدارة الأولويات",
      reversed: "إرهاق، عدم استقرار، سوء إدارة الوقت"
    },
    {
      name: "ثلاثة من العملات",
      image: "/images-webp/pentacles/three_of_pentacles.webp",
      upright: "تعاون، مهارة، اعتراف بالجهد",
      reversed: "غياب العمل الجماعي، تقدير غير كافٍ، عدم توافق"
    },
    {
      name: "أربعة من العملات",
      image: "/images-webp/pentacles/four_of_pentacles.webp",
      upright: "أمان، استقرار، التمسك بالموارد",
      reversed: "جشع، التملك، الخوف من الفقدان"
    },
    {
      name: "خمسة من العملات",
      image: "/images-webp/pentacles/five_of_pentacles.webp",
      upright: "صعوبات، معاناة مالية، عزلة",
      reversed: "تعافي، أمل، إيجاد الدعم"
    },
    {
      name: "ستة من العملات",
      image: "/images-webp/pentacles/six_of_pentacles.webp",
      upright: "كرم، توازن في العطاء والأخذ",
      reversed: "أنانية، عدم مساواة، شروط مخفية"
    },
    {
      name: "سبعة من العملات",
      image: "/images-webp/pentacles/seven_of_pentacles.webp",
      upright: "صبر، تخطيط طويل المدى، تقييم التقدم",
      reversed: "نفاد الصبر، إحباط، عدم نمو"
    },
    {
      name: "ثمانية من العملات",
      image: "/images-webp/pentacles/eight_of_pentacles.webp",
      upright: "اجتهاد، إتقان، عمل مخلص",
      reversed: "سعي للكمال المفرط، جهد ضائع، نقص التركيز"
    },
    {
      name: "تسعة من العملات",
      image: "/images-webp/pentacles/nine_of_pentacles.webp",
      upright: "استقلال، ازدهار، اكتفاء ذاتي",
      reversed: "اعتماد زائد، عدم أمان مالي، نجاح سطحي"
    },
    {
      name: "عشرة من العملات",
      image: "/images-webp/pentacles/ten_of_pentacles.webp",
      upright: "إرث، ثروة عائلية، استقرار طويل المدى",
      reversed: "خسارة مالية، صراعات عائلية، عدم استقرار"
    },
    {
      name: "صفحة العملات",
      image: "/images-webp/pentacles/page_of_pentacles.webp",
      upright: "فضول، طموح، تعلم عملي",
      reversed: "نقص التركيز، المماطلة، عدم نضج"
    },
    {
      name: "فارس العملات",
      image: "/images-webp/pentacles/knight_of_pentacles.webp",
      upright: "عمل جاد، موثوقية، تقدم ثابت",
      reversed: "عناد، كسل، بطء في الحركة"
    },
    {
      name: "ملكة العملات",
      image: "/images-webp/pentacles/queen_of_pentacles.webp",
      upright: "رعاية، حكمة عملية، وفرة",
      reversed: "حذر مفرط، اعتماد، مادية"
    },
    {
      name: "ملك العملات",
      image: "/images-webp/pentacles/king_of_pentacles.webp",
      upright: "ثروة، استقرار، إتقان الحياة المادية",
      reversed: "جشع، صلابة، سوء استخدام السلطة"
    }
  ]
};


export default cardsData;
